import { httpRequest } from '../../app/common/util/api-common.util';

export default class ConfiguracaoApi {
    static getConfigCertificacaoDigital() {
        return httpRequest(`configuracoes/certificacaodigital`, 'GET').then(json => json.data);
    }
    static gravarConfigCertificacaoDigital(body) {
        return httpRequest('configuracoes/certificacaodigital', 'PATCH', body).then(json => json);
    }
    static getConfiguracaoEmail() {
        return httpRequest(`configuracoes/email`, 'GET').then(json => json.data);
    }
    static gravarConfigEmail(body) {
        return httpRequest('configuracoes/email', 'PATCH', body).then(json => json);
    }
    static getConfiguracaoRecebimentoMaterial() {
        return httpRequest(`configuracoes/material`, 'GET').then(json => json.data);
    }
    static gravarConfigRecebimento(body) {
        return httpRequest('configuracoes/material', 'POST', body).then(json => json);
    }
    static getConfiguracaoGeral() {
        return httpRequest(`configuracoes/gerais`, 'GET').then(json => json.data);
    }
    static gravarConfiguracaoGeral(body) {
        return httpRequest('configuracoes/gerais', 'PATCH', body).then(json => json);
    }
    static getConfiguracaoLogin() {
        return httpRequest(`configuracoes/login`, 'GET').then(json => json.data);
    }

    static getConfiguracaoEditor() {
        return httpRequest(`configuracoes/editor`, 'GET', undefined).then(json => json.data);
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuracao/configuracao.api.js